define.alias("ember-composable-helpers/helpers/from-entries", "media/helpers/from-entries");